<template>
  <div>
    <div
      class="schedule schedule--confirmation background-gray min-height-inherit"
    >
      <section class="py-4 py-md-5">
        <div class="container container--lg">
          <div class="confirmation-header">
            <div class="confirmation-header__icon">
              <i class="material-icons">check</i>
            </div>
            <h1 class="title title--l text-primary weight-bolder">
              {{ current_user.user.firstname }}, tu hora de mantención se agendó
              correctamente.
            </h1>
          </div>

          <div class="confirmation box box-sm-none">
            <div class="row">
              <div class="col-md-6">
                <div class="confirmation__summary">
                  <p class="weight-bold mb-3 mb-lg-4">
                    Puedes revisar en tu correo el comprobante de reserva.
                  </p>
                  <div class="row">
                    <div v-if="current_order" class="col-6 col-md-12">
                      <div class="summary__item summary__item--confirmation">
                        <h3 class="title text-primary weight-bolder">
                          Código de reserva
                        </h3>
                        <p class="mb-0">{{ current_order.reservation_code }}</p>
                      </div>
                    </div>
                    <div
                      v-if="current_brand && current_user"
                      class="col-6 col-md-12"
                    >
                      <div
                        class="summary__item summary__item--confirmation summary__item--last"
                      >
                        <h3 class="title text-primary weight-bolder">
                          {{ current_brand.name }}
                        </h3>
                        <p class="mb-0">{{ current_user.car.model.name }}</p>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div class="col-md-6">
                <div class="confirmation__details">
                  <div v-if="current_order.service" class="summary__item">
                    <p class="summary__label text weight-bold">Servicio:</p>
                    <h3 class="title text-primary weight-bolder">
                      {{ current_order.service.name }}
                    </h3>
                  </div>
                  <div v-if="current_order.branch" class="summary__item">
                    <p class="summary__label text weight-bold">Sucursal:</p>
                    <h3 class="title text-primary weight-bolder">
                      {{ current_order.branch.name }}
                    </h3>
                    <p class="text my-1 mb-0">
                      {{ current_order.branch.address }}
                    </p>
                  </div>
                  <div v-if="current_order.user" class="summary__item">
                    <p class="summary__label text weight-bold">
                      Asesor de servicio:
                    </p>
                    <h3 class="title text-primary weight-bolder">
                      {{ current_order.user.name }}
                      {{ current_order.user.lastname }}
                    </h3>
                  </div>
                  <div class="summary__item summary__item--last">
                    <p class="summary__label text weight-bold">Fecha y hora:</p>
                    <h3 class="title text-primary weight-bolder">
                      <span class="text-capitalize">{{
                        dateFormat(current_order.appointment_date)
                      }}</span>
                      -
                      {{ formattedTime(current_order.appointment_time) }}
                      hrs
                    </h3>
                  </div>
                </div>
              </div>
            </div>
            <div class="confirmation__contact row">
              <div class="col-md-3">
                <p
                  class="text text--small weight-bolder text-uppercase mb-2 mb-lg-0"
                >
                  Datos de contacto para consultas
                </p>
              </div>
              <div
                v-if="current_order.user.phone && current_order.user.phone != 0"
                class="col-6 col-md-3 mb-2 mb-lg-0"
              >
                <p class="text text--small">
                  <span class="weight-bolder">Teléfono Servicio Técnico</span>
                  <br />
                  <a :href="`tel:${current_order.user.phone}`">
                    <i class="material-icons">phone</i>
                    <span>{{ current_order.user.phone }}</span>
                  </a>
                </p>
              </div>
              <div
                v-if="
                  current_order.user.cellphone &&
                    current_order.user.cellphone != 0
                "
                class="col-6 col-md-3 mb-2 mb-lg-0"
              >
                <p class="text text--small">
                  <span class="weight-bolder">Celular Asesor de Servicio</span>
                  <br />
                  <a :href="`tel:${current_order.user.cellphone}`">
                    <i class="material-icons">phone</i>
                    <span>{{ current_order.user.cellphone }}</span>
                  </a>
                </p>
              </div>
              <div class="col-6 col-md-3 mb-2 mb-lg-0">
                <p class="text text--small">
                  <span class="weight-bolder">Teléfono Call Center</span>
                  <br />
                  <a :href="`tel:6005700007`">
                    <i class="material-icons">phone</i>
                    <span>600 570 0007</span>
                  </a>
                </p>
              </div>
            </div>
          </div>
          <div class="confirmation__actions text-center mt-3">
            <button
              class="button button--tertiary"
              href="#"
              @click.prevent="printWindow"
            >
              <i class="button__icon material-icons">print</i>
              <span class="button__text">Imprimir comprobante</span>
            </button>
            <div
              title="Agregar a calendario"
              class="addeventatc button mt-3 mt-lg-0"
            >
              Agregar a calendario
              <span class="start">
                {{ dateFormat(current_order.appointment_date, 'MM/DD/Y') }}
                {{ formattedTime(current_order.appointment_time) }}
              </span>
              <span class="timezone">America/Santiago</span>
              <span class="title">
                [{{ current_order.reservation_code }}]
                {{ current_order.service.name }} - {{ current_brand.name }}
              </span>
              <span class="description">
                {{ current_user.user.firstname }}, tu hora de mantención se
                agendó correctamente.
                <br />
                Código de reserva: {{ current_order.reservation_code }}
              </span>
              <span class="location">{{ current_order.branch.address }}</span>
            </div>
          </div>
        </div>
      </section>
    </div>

    <div class="background-gray py-4 d-md-none">
      <div class="container-fluid">
        <router-link
          :to="{ name: 'home' }"
          class="button button--secondary w-100"
        >
          <span class="button__text">Volver al inicio</span>
        </router-link>
      </div>
    </div>
  </div>
</template>

<script>
import moment from 'moment';
import { mapState } from 'vuex';

export default {
  name: 'ScheduleConfirmation',
  beforeRouteLeave(to, from, next) {
    this.$store.commit('reset_current_order');
    next();
  },
  data() {
    return {
      site: {
        id: process.env.VUE_APP_BRAND_ID || '',
        label: process.env.VUE_APP_BRAND__LABEL || '',
        url: process.env.VUE_APP_BRAND_SITE_URL || '',
      },
    };
  },
  created() {
    let addevent = document.createElement('script');
    addevent.setAttribute(
      'src',
      'https://addevent.com/libs/atc/1.6.1/atc.min.js',
    );
    addevent.async = true;
    addevent.defer = true;
    document.head.appendChild(addevent);
  },
  mounted() {
    this.$store.commit('set_title', '');

    this.executeDataLayer();
  },
  computed: {
    ...mapState(['current_brand', 'current_user', 'current_order']),
  },
  methods: {
    printWindow() {
      window.print();
    },
    formattedTime(time) {
      return time.substring(0, time.length - 3);
    },
    sha256: async function(message) {
      const encoder = new TextEncoder();
      const data = encoder.encode(message);
      const hash = await window.crypto.subtle.digest('SHA-256', data);

      return Array.from(new Uint8Array(hash))
        .map(b => b.toString(16).padStart(2, '0'))
        .join('');
    },
    executeDataLayer: async function() {
      if (!window.dataLayer) {
        return;
      }

      const brand = this.current_user.car.model.brand
        ? this.current_user.car.model.brand.name.toLowerCase()
        : '';

      let eventData = {
        event: 'generate_lead',
        currency: 'CLP',
        value: null,
        tipo: this.normalizeText(this.current_order.service.name),
        user_id: await this.sha256(this.current_user.user.rut),
        correo: this.current_user.user.email,
        brand: this.normalizeText(brand),
        model: this.normalizeText(
          this.current_user.car.model.name.toLowerCase(),
        ),
      };

      console.log('Sent to dataLayer', eventData);

      window.dataLayer.push(eventData);
    },
    normalizeText(text) {
      return text
        .replace(/\s/g, '_')
        .toLowerCase()
        .normalize('NFD')
        .replace(/[\u0300-\u036f]/g, '');
    },
    dateFormat(date, format) {
      return moment(date)
        .locale('es')
        .format(format || 'dddd DD MMMM');
    },
  },
};
</script>
